module.exports = __webpack_public_path__ + "static/media/DigitalOcean.538200c5.svg";